import React, { useState, useEffect } from 'react';
import { Alert } from '@material-ui/lab';
import { useMediaQuery } from '@material-ui/core';

import { getRequest } from 'utils/api';
import { useDispatch } from 'react-redux';
import { setAgencyOffersCount, setUnseenNotificationsCount } from 'features/utilsSlice';
import useNotLoggedInRedirect from 'hooks/useNotLoggedInRedirect';
import ToDosMask from 'components/agency/ToDosMask';

const alertStyle = { margin: '70px 15px 20px 15px', width: 'auto' };

const ThisWeekTodos = () => {
  const [todos, setTodos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedNetworkIds, setSelectedNetworkIds] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));
  const dispatch = useDispatch();

  useNotLoggedInRedirect();

  useEffect(() => {
    getRequest({ endpoint: 'notifications/unseen_count' })
      .then(count => dispatch(setUnseenNotificationsCount(count)))
      .catch(() => {});
  }, [dispatch]);

  useEffect(() => {
    getRequest({ endpoint: 'gig_invitations/agency_offers_count' })
      .then(count => dispatch(setAgencyOffersCount(count)))
      .catch(() => {});
  }, [dispatch]);

  useEffect(() => {
    setIsLoading(true);

    getRequest({
      endpoint: 'milestones/agency_milestones',
      query: { do_this_week: true, network_ids: selectedNetworkIds, q: searchValue },
    })
      .then(todos => {
        setTodos(todos);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));

    () => setSelectedNetworkIds([]);
  }, [selectedNetworkIds, searchValue]);

  if (isMobile) {
    return (
      <Alert style={alertStyle} severity="info">
        Agency accounts are not currently optimized for mobile. Please sign in via laptop / PC
      </Alert>
    );
  }

  return (
    <ToDosMask
      title="Do This Week"
      todos={todos}
      setTodos={setTodos}
      isLoading={isLoading}
      selectedNetworkIds={selectedNetworkIds}
      setSelectedNetworkIds={setSelectedNetworkIds}
      setSearchValue={setSearchValue}
      searchValue={searchValue}
    />
  );
};

export default ThisWeekTodos;
